import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Product } from '../../../../types';

interface DeleteProductDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  product: Product | null;
}

const DeleteProductDialog: React.FC<DeleteProductDialogProps> = ({
  open,
  onClose,
  onConfirm,
  product,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          borderRadius: '8px',
        },
      }}
    >
      <DialogTitle sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
        {t('admin.confirmDelete')}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
          {t('admin.areYouSureDelete')} "{product?.title}"? {t('admin.cannotBeUndone')}.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          sx={{
            bgcolor: '#ff3366',
            '&:hover': { bgcolor: '#cc0033' },
          }}
        >
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteProductDialog;